import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { ProgressSpinner } from "primereact/progressspinner";
import { useDraftRetriever } from "../../api/DataAPI";
import useStrings from "../../api/StringsAPI";
import { isErrorStatus, statusTagProps } from "./statusTag";

interface Props {
  visible: boolean;
  onHide: () => void;
  documentId: number | null;
}

export default function ApplicationDetailsDialog({ visible, onHide, documentId }: Props) {
  const str = useStrings();
  const query = useDraftRetriever(documentId);

  const doc = query.data?.data;

  const Field = ({ label, value }: { label: string; value: string | number | null | undefined }) => (
    <div style={{ marginBottom: 10 }}>
      <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 3 }}>{label}</label>
      <span>{value || '-'}</span>
    </div>
  );

  return (
    <Dialog header={str('applicationDetailsTitle')} visible={visible} onHide={onHide} style={{ width: '700px' }} modal>
      {query.isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 30 }}>
          <ProgressSpinner />
        </div>
      )}

      {query.isSuccess && doc && (
        <div>
          {/* Status */}
          <div style={{ marginBottom: 20 }}>
            <Tag value={doc.status?.name} {...statusTagProps(doc.status?.id)} style={{ fontSize: '1rem' }} />
            {doc.statusText && (
              <p style={{ color: isErrorStatus(doc.status?.id) ? 'var(--red-500)' : 'var(--text-color-secondary)', marginTop: 5 }}>
                {doc.statusText}
              </p>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 15 }}>
            <Field label={str('taxNumber')} value={doc.taxNumber} />
            <Field label={str('orgName')} value={doc.orgName} />
            <Field label={str('deviceSerial')} value={doc.deviceSerial} />
            <Field label={str('sealNumber')} value={doc.sealNumber} />
            <Field label={str('samModule')} value={doc.samModule} />
            <Field label={str('fiscalNumber')} value={doc.fiscalNumber} />
            <Field label={str('simNumber')} value={doc.simNumber} />
            <Field label={str('region')} value={doc.region?.name} />
            <Field label={str('district')} value={doc.district?.name} />
            <Field label={str('street')} value={doc.street?.name} />
            <Field label={str('addressAdditional')} value={doc.addressAdditional} />
            <Field label={str('phone')} value={doc.phone} />
            <Field label={str('email')} value={doc.email} />
            <Field label={str('activityType')} value={doc.activityType?.name} />
            <Field label={str('objectType')} value={doc.objectType?.name} />
            <Field label={str('deviceModel')} value={doc.deviceModel?.name} />
            <Field label={str('creatorUser')} value={doc.creatorUser?.username} />
          </div>
        </div>
      )}
    </Dialog>
  );
}
